import { useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';

import { TEALIUM_AD_TYPE } from 'src/app/shared/constants/dispatcherId';
import { getClassificationDataByAdCenterIds } from 'src/app/utils/classifications';
import { getSelectedProduct } from 'src/app/utils/getSelectedProduct';
import { log } from 'src/app/utils/logging';
import dispatchTealium from 'src/app/v1/state/dispatcher/tealium';
import { actionResetSelectedProductId } from 'src/app/v1/state/modules/formData/selectedProductId';
import { actionResetCart } from 'src/app/v1/state/modules/session/cart';
import { actionResetProductSet } from 'src/app/v1/state/modules/session/productSet';
import type { AppState } from 'src/types/appState';

const useRefreshAdProductSet = () => {
  const {
    subClassificationId,
    productSet,
    formCategoryId,
    formSubCategoryId,
    selectedProductId,
  } = useSelector(
    (state: AppState) => ({
      subClassificationId: state.session.seekSubClassificationId,
      formCategoryId: state.formData.categoryId,
      formSubCategoryId: state.formData.subCategoryId,
      productSet: state.session.productSet,
      selectedProductId: state.formData.selectedProductId,
    }),
    shallowEqual,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (formCategoryId && formSubCategoryId && subClassificationId) {
      const result = getClassificationDataByAdCenterIds(
        parseInt(formCategoryId, 10),
        parseInt(formSubCategoryId, 10),
      );

      const seekSubClassificationId = result?.seekSubClassificationId;

      if (seekSubClassificationId !== subClassificationId) {
        log.error('useRefreshAdProductSet | checkSubClassification: Mismatch', {
          formCategoryId,
          formSubCategoryId,
          seekSubClassificationId,
          subClassificationId,
        });
      }
    }
  }, [formCategoryId, formSubCategoryId, subClassificationId]);

  useEffect(() => {
    // REFACTOR: Fix selectedProductId not available in product set
    if (productSet && selectedProductId) {
      const selectedProductItem = getSelectedProduct(
        selectedProductId,
        productSet,
      );
      if (!selectedProductItem) {
        // May not need to reset product set since we fetch a new product set everytime
        // we land in CAJA
        dispatch(actionResetCart());
        dispatch(actionResetProductSet());
        dispatch(actionResetSelectedProductId());
      } else {
        dispatch(dispatchTealium(TEALIUM_AD_TYPE, selectedProductItem.name));
      }
    }
  }, [productSet, selectedProductId, dispatch]);
};

export { useRefreshAdProductSet };
